import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Select } from '@/shared/components/Select';
import { Button } from '@/shared/components/Button';
import { ApiError } from '@/lib/api-client';
import { useUpdateStudentStatus } from '../hooks/useStudents';
const STATUS_OPTIONS = [
    { value: 'active', label: 'Activo' },
    { value: 'temporary_leave', label: 'Baja temporal' },
    { value: 'inactive', label: 'Inactivo (baja definitiva)' },
    { value: 'approved', label: 'Aprobado' },
];
/** Updates the student's status (active / temporary_leave / inactive / approved). */
export function ChangeStudentStatusForm({ student, onSuccess }) {
    const [serverError, setServerError] = useState(null);
    const [status, setStatus] = useState(student.status);
    const updateStatus = useUpdateStudentStatus(student.id);
    function handleSubmit(e) {
        e.preventDefault();
        setServerError(null);
        if (status === student.status) {
            onSuccess();
            return;
        }
        updateStatus.mutate(status, {
            onSuccess: () => onSuccess(),
            onError: (err) => {
                setServerError(err instanceof ApiError ? err.message : 'Ha ocurrido un error.');
            },
        });
    }
    return (_jsxs("form", { onSubmit: handleSubmit, className: "flex flex-col gap-4", noValidate: true, children: [_jsxs("p", { className: "text-sm", style: { color: 'var(--fg-2)' }, children: ["Estado actual: ", _jsx("strong", { style: { color: 'var(--fg)' }, children: labelFor(student.status) }), "."] }), _jsx(Select, { label: "Nuevo estado", value: status, onChange: (e) => setStatus(e.target.value), options: STATUS_OPTIONS }), _jsx("p", { className: "text-xs", style: { color: 'var(--fg-2)' }, children: hintFor(status) }), serverError && (_jsx("p", { role: "alert", className: "text-sm text-red-600 dark:text-red-400", children: serverError })), _jsx(Button, { type: "submit", loading: updateStatus.isPending, disabled: status === student.status, className: "w-full", children: "Guardar cambios" })] }));
}
function labelFor(status) {
    return STATUS_OPTIONS.find((o) => o.value === status)?.label ?? status;
}
function hintFor(status) {
    switch (status) {
        case 'active':
            return 'El alumno aparece en las listas de asistencia y recibe notificaciones.';
        case 'temporary_leave':
            return 'No aparece en listas de asistencia mientras esté en baja temporal.';
        case 'inactive':
            return 'El alumno deja la academia. No aparecerá en listas ni en búsquedas activas.';
        case 'approved':
            return 'El alumno ha aprobado la oposición. Aparecerá en la sección de aprobados de la landing.';
        default:
            return '';
    }
}
//# sourceMappingURL=ChangeStudentStatusForm.js.map